import script from "./TestItemFields.vue?vue&type=script&lang=ts&setup=true"
export * from "./TestItemFields.vue?vue&type=script&lang=ts&setup=true"

import "./TestItemFields.vue?vue&type=style&index=0&id=624761fc&lang=css"

const __exports__ = script;

export default __exports__